import type { IBookingDetail, ISendMailRequest } from '../types/schema'

/**
 * Maps a booking response onto the body `sendmail.php` expects. Key names must match exactly —
 * `email.html` substitutes on them and both files are unchanged.
 *
 * `branch_long_name` is fed from `detail.branch_name`: the booking response reuses that key for the
 * long name. `redeem_at` is discarded by PHP, which always prints today, but is sent anyway.
 */
export function toSendMailPayload(
  detail: IBookingDetail,
  remark: string
): ISendMailRequest & { branch_id: number } {
  const gift = detail.gift_used?.[0]

  return {
    bpds_id: detail.bpds_id,
    customer_name: detail.cust_name,
    customer_phone: detail.cust_phone,
    customer_email: detail.cust_email,
    guest: detail.qty_people,
    appt_date: detail.appt_date,
    appt_time: detail.appt_time,
    total_hours: detail.total_hours,
    branch_id: detail.branch_id,
    branch_long_name: detail.branch_name,
    branchlong_desc: detail.branchlong_desc,
    map_link: detail.map_link,
    branch_address: detail.branch_address,
    remark: remark ?? '',
    gift_number: gift?.gift_number ?? '',
    gift_product: gift?.product ?? '',
    gift_expired: gift?.expired ?? '',
    redeem_at: new Date().toISOString()
  }
}
